import PlansList from "@/molecules/PlansList";

const FranchisePlans = () => {
  const franchisePlans = [
    {
      cardTitle: "Intro",
      minsPlusChat: "75 minutes",
      price: "130",
      setUpFree: "$50",
      additionalMins: "2",
      features: [
        "24/7 Live Answering",
        "Live Chat",
        "Business Phone Line",
        "Scheduling Solutions",
        "Mobile app",
        "Team Messaging",
      ],
      planid: process.env.IS_LIVE ? "5533" : "5517",
    },
    {
      isMostPopularValue: true,
      cardTitle: "Growth",
      minsPlusChat: "100 minutes",
      price: "170",
      setUpFree: "$50",
      btnVariant: "primary",
      additionalMins: "1.80",
      features: [
        "24/7 Live Answering",
        "Live Chat",
        "Business Phone Line",
        "Scheduling Solutions",
        "Mobile app",
        "Team Messaging",
      ],
      planid: process.env.IS_LIVE ? "5534" : "5518",
    },
  ];

  return (
    <PlansList
      plansData={franchisePlans}
      showLargerPlansHandler={null}
      isLargerPlansVisible={false}
    />
  );
};

export default FranchisePlans;
